/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }

(function() {
  let TRIX_CONTROLS = undefined;
  const Cls = (Utility.TrixCustomizations = class TrixCustomizations {
    static initClass() {
      TRIX_CONTROLS = "trix-toolbar, .trix-actions";
    }

    static prepare($trix) {
      if ($trix.siblings('trix-toolbar').find('button.embed').length === 0) {
        const buttonHTML = "<button type=\"button\" class=\"embed trix-button\" data-trix-action=\"x-embed\" title=\"Embed\">img</button>";
        $trix.siblings('trix-toolbar').find('.trix-button-group--text-tools').append(buttonHTML);
      }

      $trix.addClass('needsclick');
      $trix.siblings('trix-toolbar').find('button').addClass('needsclick');
      if ($trix.hasClass('hide-controls')) {
        $trix.siblings(TRIX_CONTROLS).hide();
        $trix.on('trix-focus', function() {
          $(this).prev('trix-toolbar').fadeIn();
          $(this).siblings('.trix-actions').fadeIn();
          return $("trix-toolbar").not( "[id='trix-toolbar-" + $trix.attr("trix-id") + "']" ).fadeOut();
        });
      }
      if ($trix.hasClass('autofocus')) {
        $trix.focus();
      }
      if ($trix.hasClass('autosave')) {
        const action = $trix.closest("form").attr("action");
        $trix.on('trix-blur', function() {
          let field;
          if (action.split("/")[1] === 'assessments') {
            return $.ajax({
              method: 'put',
              url: action + "/autosave",
              data: {
                assessment: {
                  note_attributes: {
                    body: $("#" + $(this).attr('input')).val(),
                    id: $('#assessment_note_attributes_id').val()
                  }
                }
              },
              dataType: 'script'
            });

          } else if (parseInt(action.split("/").pop()) > 0) {
            field = $(this).data('field') || "body";
            return $.ajax({
              method: 'put',
              url: action + "/autosave",
              data: { trix: { name: field, value: $("#" + $(this).attr('input')).val() }},
              dataType: 'script'
            });
          } else if (action.split("/")[1] === 'checkins') {
            field = $(this).data('field');
            return $.ajax({
              method: 'put',
              url: "/" + action.split("/").slice(1,3).join("/") + "/autosave",
              data: { trix: { name: field, value: $("#" + $(this).attr('input')).val() }},
              dataType: 'script'
            });
          } else {
            return localStorage["trix-autosave" + action] = JSON.stringify($(this)[0].editor);
          }
        });
        if (localStorage["trix-autosave" + action] !== undefined) {
          return $trix[0].editor.loadJSON(JSON.parse(localStorage["trix-autosave" + action]));
        }
      }
    }
  });
  Cls.initClass();
  return Cls;
})();
